import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const BRAND_BY_UUID_RESOURCE = "brand" as const;
export const BRAND_BY_UUID_API_PATH = `/v1/${BRAND_BY_UUID_RESOURCE}/{uuid}` as const;

export type BrandByUuidParameters = paths[typeof BRAND_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type BrandByUuidResponse =
  paths[typeof BRAND_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useBrandByUuidQuery(uuid: string, options?: Options<BrandByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<BrandByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [BRAND_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<BrandByUuidResponse>(`/v1/${BRAND_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
